<template>
    <div>
        <div class="topTit" id="topTit" ref="topTit" v-if="showTopTit">
            <van-icon @click.stop="goBack" name="arrow-left" color="#515151" size="0.28rem" />
            <van-notice-bar class="navText" color="#333" background="#fff" v-if="topTitle">{{topTitle}}</van-notice-bar>
            <div class="refresh" @click.stop="refreshClick">
                <img src="~assets/images/recmmendImg/refresh.png" />
            </div>
        </div>
        <div class="maskLoading" v-show="maskLoadingflag">
            <img src="~assets/images/load.svg" alt />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import primaryApi from "@/utils/primaryApi";
import { Icon, NoticeBar } from "vant";
Vue.use(Icon);
Vue.use(NoticeBar);
export default {
    inject: ["reload"],
    data() {
        return {
            maskLoadingflag: true, //首页进入页面开始的动画(转圆圈)
            topTitle: "", //头部标题
            showTopTit: false, //乐园显示顶部导航栏
        }
    },
    created() {
        if (primaryApi.isSource == "pd") {
            primaryApi.setNativeTitleShow(false); // 隐藏原生顶栏
            //乐园显示顶部导航栏
            this.showTopTit = true;
        }
    },
    mounted() {
        //233乐园后退回调
        window["goBackResult"] = (result) => {
            if (result == "failed") {
                //乐园后退失败则关闭界面
                primaryApi.closeActivity();
            }
        };
    },
    methods: {
        // 控制tit和maskLoading
        assignment(topTitle, maskLoadingflag) {
            if (topTitle !== "") {
                this.topTitle = topTitle;
                document.title = topTitle; // 活动标题
            }
            if (maskLoadingflag !== "") {
                this.maskLoadingflag = maskLoadingflag;
            }
        },
        //刷新
        refreshClick() {
            this.reload();
        },
        //后退
        goBack() {
            if (primaryApi.isSource == "pd") {
                //乐园环境
                primaryApi.goBack();
            }
        },
    }
}
</script>
<style scoped>
    .maskLoading {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        background: rgba(189, 84, 28, 0.98);
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .maskLoading img {
        display: block;
        width: 0.4rem;
        height: 0.4rem;
        animation: loading 2s linear 0s infinite;
    }
    @keyframes loading {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }
    .topTit {
        width: 100%;
        height: 0.46rem;
        line-height: 0.46rem;
        background-color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 998;
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 0 0.05rem;
    }
    .refresh {
        /* position: absolute; */
        /* right: 0.05rem; */
        /* top: 0; */
        height: 100%;
        width: 0.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        font-size: 0;
    }
    .refresh img {
        width: 22.8px;
        height: 30.6px;
    }
    .refresh span {
        color: #515151;
        font-size: 0.06rem;
        line-height: 0.2rem;
        /* transform: scale(0.9, 0.9); */
        margin-top: -0.1rem;
    }
    .van-notice-bar {
        width: 100%;
        text-align: center;
        font-size: 0.16rem;
        padding: 0 0.1rem;
    }
    .navText >>> .van-notice-bar__content {
        text-align: center;
        min-width: 100%;
    }
</style>